var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 1.25C7.16421 1.25 7.5 1.58579 7.5 2V5C7.5 5.41421 7.16421 5.75 6.75 5.75C6.33579 5.75 6 5.41421 6 5V2C6 1.58579 6.33579 1.25 6.75 1.25ZM18.75 1.25C19.1642 1.25 19.5 1.58579 19.5 2V5C19.5 5.41421 19.1642 5.75 18.75 5.75C18.3358 5.75 18 5.41421 18 5V2C18 1.58579 18.3358 1.25 18.75 1.25Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5.5C2.5 3.98122 3.73122 2.75 5.25 2.75H20.25C21.7688 2.75 23 3.98122 23 5.5V20C23 21.5188 21.7688 22.75 20.25 22.75H5.25C3.73122 22.75 2.5 21.5188 2.5 20V5.5ZM5.25 4.25C4.55964 4.25 4 4.80964 4 5.5V20C4 20.6904 4.55964 21.25 5.25 21.25H20.25C20.9404 21.25 21.5 20.6904 21.5 20V5.5C21.5 4.80964 20.9404 4.25 20.25 4.25H5.25Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 8.5C2.5 8.08579 2.83579 7.75 3.25 7.75H22.25C22.6642 7.75 23 8.08579 23 8.5C23 8.91421 22.6642 9.25 22.25 9.25H3.25C2.83579 9.25 2.5 8.91421 2.5 8.5Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic-calendar.60fbf589a84d6be8b6ba15f4ab71b162.svg";
export { ForwardRef as ReactComponent };